<div class="kpi-cards" *ngIf="snapshot">
    <div class="kpi-card">
        <div class="kpi-label">{{ 'pages.collections.analytics.reminder_total' | translate }}</div>
        <div class="kpi-value">{{ snapshot.totalReminders.current | number }}</div>
        <div class="kpi-subtitle" *ngIf="totalDelta !== null"
             [class.positive]="totalDelta > 0" [class.negative]="totalDelta < 0" [class.muted]="totalDelta === 0">
            <span *ngIf="totalDelta > 0">&#9650;</span>
            <span *ngIf="totalDelta < 0">&#9660;</span>
            <span *ngIf="totalDelta === 0">&mdash;</span>
            {{ totalDelta > 0 ? '+' : '' }}{{ totalDelta | number }} {{ 'pages.collections.analytics.vs_previous' | translate }}
        </div>
    </div>
    <div class="kpi-card">
        <div class="kpi-label">{{ 'pages.collections.analytics.reminder_delivery_rate' | translate }}</div>
        <div class="kpi-value">{{ snapshot.deliveryRate.current }}%</div>
        <div class="kpi-subtitle" *ngIf="deliveryRateDelta !== null"
             [class.positive]="deliveryRateDelta > 0" [class.negative]="deliveryRateDelta < 0" [class.muted]="deliveryRateDelta === 0">
            <span *ngIf="deliveryRateDelta > 0">&#9650;</span>
            <span *ngIf="deliveryRateDelta < 0">&#9660;</span>
            <span *ngIf="deliveryRateDelta === 0">&mdash;</span>
            {{ deliveryRateDelta > 0 ? '+' : '' }}{{ deliveryRateDelta }}% {{ 'pages.collections.analytics.vs_previous' | translate }}
        </div>
    </div>
    <div class="kpi-card">
        <div class="kpi-label">{{ 'pages.collections.analytics.reminder_failure_rate' | translate }}</div>
        <div class="kpi-value">{{ snapshot.failureRate.current }}%</div>
        <div class="kpi-subtitle" *ngIf="failureRateDelta !== null"
             [class.positive]="failureRateDelta < 0" [class.negative]="failureRateDelta > 0" [class.muted]="failureRateDelta === 0">
            <span *ngIf="failureRateDelta < 0">&#9660;</span>
            <span *ngIf="failureRateDelta > 0">&#9650;</span>
            <span *ngIf="failureRateDelta === 0">&mdash;</span>
            {{ failureRateDelta > 0 ? '+' : '' }}{{ failureRateDelta }}% {{ 'pages.collections.analytics.vs_previous' | translate }}
        </div>
    </div>
    <div class="kpi-card">
        <div class="kpi-label">{{ 'pages.collections.analytics.reminder_users_reached' | translate }}</div>
        <div class="kpi-value">{{ snapshot.uniqueUsersReached.current | number }}</div>
        <div class="kpi-subtitle" *ngIf="usersReachedDelta !== null"
             [class.positive]="usersReachedDelta > 0" [class.negative]="usersReachedDelta < 0" [class.muted]="usersReachedDelta === 0">
            <span *ngIf="usersReachedDelta > 0">&#9650;</span>
            <span *ngIf="usersReachedDelta < 0">&#9660;</span>
            <span *ngIf="usersReachedDelta === 0">&mdash;</span>
            {{ usersReachedDelta > 0 ? '+' : '' }}{{ usersReachedDelta | number }} {{ 'pages.collections.analytics.vs_previous' | translate }}
        </div>
    </div>
    <div class="kpi-card">
        <div class="kpi-label">{{ 'pages.collections.analytics.reminder_active_subscriptions' | translate }}</div>
        <div class="kpi-value">{{ snapshot.activeSubscriptions.current | number }}</div>
        <div class="kpi-subtitle muted">{{ 'pages.collections.analytics.reminder_current_snapshot' | translate }}</div>
    </div>
</div>
